import {
  OccupancyInsightsFiltersState,
  OccupancyInsightsFiltersActionTypes,
  READ_OCCUPANCY_INSIGHTS_FILTERS_REQUEST,
  READ_OCCUPANCY_INSIGHTS_FILTERS_SUCCESS,
  READ_OCCUPANCY_INSIGHTS_FILTERS_FAILURE
} from "store/reducers/occupancy-insights/readOccupancyInsightsFilters/types";

const defaultState: OccupancyInsightsFiltersState = {
  isLoading: false,
  errorMessage: ""
};

export default function readOccupancyInsightsFilters(state = defaultState, action: OccupancyInsightsFiltersActionTypes): OccupancyInsightsFiltersState {
  switch (action.type) {
    case READ_OCCUPANCY_INSIGHTS_FILTERS_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case READ_OCCUPANCY_INSIGHTS_FILTERS_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case READ_OCCUPANCY_INSIGHTS_FILTERS_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};